<template>
  <div
    class="d-flex flex-column align-center justify-center text-center"
    :class="`py-${py}`"
  >
    <v-progress-circular :size="size" :color="color" indeterminate />

    <div v-if="label" class="mt-6 neutral8--text text-body-1">
      {{ label }}
    </div>

    <div v-if="labels.length" :class="textClass" class="mt-6">
      {{ labels[index] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",

  data() {
    return {
      interval: null,
      index: 0,
    };
  },

  props: {
    size: {
      type: [String, Number],
      default: "42",
    },

    color: {
      type: String,
      default: "primary",
    },

    label: {
      type: String,
      default: "",
    },

    labels: {
      type: Array,
      default: () => [],
    },

    textClass: {
      type: String,
      default: "neutral6--text text-body-1",
    },

    py: {
      type: String,
      default: "4",
    },
  },

  beforeMount() {
    if (this.label.length) this.handleLabelInterval();
  },

  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  },

  methods: {
    handleLabelInterval() {
      this.interval = setInterval(() => {
        if (this.index === this.labels.length - 1) this.index = 0;
        else this.index++;
      }, 5000);
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
